import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

import { States } from '@app/shared/shared.models';

@Component({
  selector: 'app-shared-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
})
export class SearchComponent implements OnInit {
  @Input() inputSearch: string;
  @Input() isHomePage: boolean;
  @Input() isOverviewPage: boolean;
  @Output() search = new EventEmitter<string>();

  errorMessage = '';

  selectedValue = '';
  sugestedState: string[] = [];

  private states: string[] = [];
  private statesAbbreviations: string[] = [];

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.selectedValue = this.inputSearch;
    for (const state in States) {
      if (state) {
        this.states.push(state);
        this.statesAbbreviations.push(States[state]);
      }
    }
  }

  onClear(): void {
    this.errorMessage = '';
    this.selectedValue = '';
    if (!this.isHomePage || !this.isOverviewPage) {
      this.search.emit('');
    }
  }

  onSearch(): void {
    this.errorMessage = '';
    if (this.isNumeric(this.selectedValue)) {
      // We know is a Zip code
      if (!this.isValizZip(this.selectedValue)) {
        this.errorMessage = 'Please enter a valid zip code';
        return;
      }
      this.onValidSearch();
      return;
    }
    // If is not numeric then is a State Search
    const found = this.states.find((element) => element === this.selectedValue);
    if (found) {
      this.onValidSearch();
      return;
    }
    this.errorMessage = 'Please select a valid state';
  }

  searchState(event: any): void {
    const query = event.query.toString().toLowerCase();

    const abbreviations = this.statesAbbreviations.filter((c) => c.toLowerCase().startsWith(query));

    this.sugestedState = this.states.filter((c) => c.toLowerCase().indexOf(query) > -1);

    abbreviations.forEach((c) => {
      const indexOf = this.statesAbbreviations.indexOf(c);
      const value = this.states[indexOf];
      const found = this.sugestedState.find((element) => element === value);
      if (!found) {
        this.sugestedState.push(this.states[indexOf]);
      }
    });
  }

  private isNumeric(value: any): boolean {
    return !isNaN(value - parseFloat(value));
  }

  private isValizZip(value: string): boolean {
    return /^\d{5}$|^\d{5}-\d{4}$/.test(value);
  }

  private onValidSearch() {
    if (this.isHomePage || this.isOverviewPage) {
      void this.router.navigate(['jobs/', { stateZip: this.selectedValue }]);
    } else {
      this.search.emit(this.selectedValue);
    }
    return;
  }
}
